/**
 * DayDrawer — side-sheet listing all events on a specific day.
 *
 * Uses the existing shadcn `Sheet` primitive. Opens when the user
 * clicks a day cell with ≥1 event on the month view. Each row is an
 * `EventCard` so the affordances (edit/dismiss/delete) match the
 * list view exactly.
 */
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import EventCard from "./EventCard";
import { formatEventDate } from "./utils";

export default function DayDrawer({
  open,
  onOpenChange,
  date,
  items,
  onDismiss,
  onEdit,
  onDelete,
}) {
  const activeItems = items || [];
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="right"
        data-testid="calendar-day-drawer"
        className="w-full sm:max-w-md overflow-y-auto"
      >
        <SheetHeader>
          <SheetTitle data-testid="calendar-day-drawer-title">
            {date ? formatEventDate(date.toISOString()) : "Events"}
          </SheetTitle>
          <SheetDescription>
            {activeItems.length === 1
              ? "1 event on this day."
              : `${activeItems.length} events on this day.`}
          </SheetDescription>
        </SheetHeader>
        <ul className="mt-6 space-y-3">
          {activeItems.map((ev) => (
            <EventCard
              key={ev.id}
              event={ev}
              onDismiss={onDismiss}
              onEdit={onEdit}
              onDelete={onDelete}
              testidPrefix="calendar-day-drawer-event"
            />
          ))}
        </ul>
      </SheetContent>
    </Sheet>
  );
}
